/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import {
  HasCreateAccess,
  HasReadAccess,
  HasWriteAccess,
  IsPortalUser,
  IsSuperUser,
} from "../../../../_helpers/AccessControlHelpers";
import AsideMenuItem from "./AsideMenuItem";
import {
  ACCOUNTING_MODEL,
  BRANCH_MODEL,
  INVESTIGATION_MODEL,
  INVOICE_MODEL,
  NOTICE_MODEL,
  ORDER_MODEL,
  PRODUCT_MODEL,
} from "../../../../_helpers/AppModels";

export function AsideMenuList({ layoutProps, user }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">داشبورد</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*Orders Menu*/}
        {(HasReadAccess(user, ORDER_MODEL) || IsSuperUser(user)) && (
          <>
            <li className="menu-section ">
              <h4 className="menu-text">بازرگانی</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            {IsPortalUser(user) && (
                <>
              <AsideMenuItem
                getMenuItemActive={getMenuItemActive(
                  "/sales/orders/new",
                  false
                )}
                icon={toAbsoluteUrl("/media/svg/icons/Shopping/Bag1.svg")}
                text={"ثبت سفارش جدید"}
                url={"/sales/orders/new"}
              />
              <AsideMenuItem
                getMenuItemActive={getMenuItemActive("/profile/wallet", false)}
                icon={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")}
                text={"کیف پول من"}
                url={"/profile/wallet"}
                />
                </>

            )}

            <AsideMenuItem
              getMenuItemActive={getMenuItemActive("/base/schedules", false)}
              icon={toAbsoluteUrl("/media/svg/icons/Code/Time-schedule.svg")}
              text={"سفارشات مواد اولیه"}
              url={"/reports"}
            />
          </>
        )}

        {/*Investigation Menu*/}
        {(HasReadAccess(user, INVESTIGATION_MODEL) || IsSuperUser(user)) && (
          <>
            <li className="menu-section ">
              <h4 className="menu-text">کنترل کیفیت</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            <AsideMenuItem
              getMenuItemActive={getMenuItemActive("/qc/investigations", false)}
              icon={toAbsoluteUrl("/media/svg/icons/General/Star.svg")}
              text={"گزارشات بازرسی"}
              url={"/qc/investigations"}
              badge={"Investigation"}
            />
          </>
        )}

        {/*Notice Menu*/}
        {(HasReadAccess(user, NOTICE_MODEL) || IsSuperUser(user)) && (
          <>
            <li className="menu-section ">
              <h4 className="menu-text">عملیات</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            <AsideMenuItem
              getMenuItemActive={getMenuItemActive("/operation/notices", false)}
              icon={toAbsoluteUrl(
                "/media/svg/icons/General/Notifications1.svg"
              )}
              text={"اطلاعیه ها"}
              url={"/operation/notices"}
              badge={"Notice"}
            />
          </>
        )}

        {/*Accounting Menu*/}
        {(HasReadAccess(user, INVOICE_MODEL) || IsSuperUser(user)) && (
          <>
            <>
              <li className="menu-section ">
                <h4 className="menu-text">مالی</h4>
                <i className="menu-icon flaticon-more-v2"></i>
              </li>

              <AsideMenuItem
                getMenuItemActive={getMenuItemActive(
                  "/accounting/invoices",
                  false
                )}
                icon={toAbsoluteUrl("/media/svg/icons/Files/File.svg")}
                text={"فاکتور ها"}
                url={"/accounting"}
                badge={"Invoice"}
              />
            </>
          </>
        )}

        {/*Base Data*/}
        {(HasCreateAccess(user, BRANCH_MODEL) || IsSuperUser(user)) && (
          <>
            <li className="menu-section ">
              <h4 className="menu-text">اطلاعات پایه</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            {/*Branch Menu*/}
            <AsideMenuItem
              getMenuItemActive={getMenuItemActive("/base/branches", false)}
              icon={toAbsoluteUrl("/media/svg/icons/Food/Dinner.svg")}
              text={"مدیریت شعبه ها"}
              url={"/base/branches"}
            />
          </>
        )}

        {(HasCreateAccess(user, PRODUCT_MODEL) || IsSuperUser(user)) && (
          <AsideMenuItem
            getMenuItemActive={getMenuItemActive("/base/products", false)}
            icon={toAbsoluteUrl("/media/svg/icons/Food/Pizza.svg")}
            text={"مدیریت محصولات"}
            url={"/base/products"}
          />
        )}
        <AsideMenuItem
          getMenuItemActive={getMenuItemActive('/user-profile', false)}
          icon={toAbsoluteUrl(
              "/media/svg/icons/Shopping/Money.svg"
          )}
          text={'کیف پول من'}
          url={'/user-profile'}
          />

        {IsSuperUser(user) && (
          <>
            {/*USERS MENU*/}

            <li className="menu-section ">
              <h4 className="menu-text">تنظیمات</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            <AsideMenuItem
              getMenuItemActive={getMenuItemActive("/base/users", false)}
              icon={toAbsoluteUrl(
                "/media/svg/icons/Communication/Add-user.svg"
              )}
              text={"مدیریت کاربران"}
              url={"/base/users"}
            />

            {/*ACCESS SETTINGS MENU*/}

            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/base",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/base">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Code/Error-circle.svg"
                    )}
                  />
                </span>
                <span className="menu-text">سطوح دسترسی</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className="menu-item  menu-item-parent"
                    aria-haspopup="true"
                  >
                    <span className="menu-link">
                      <span className="menu-text">گروه های دسترسی</span>
                    </span>
                  </li>

                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/base/access-groups"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/base/access-groups">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">گروه های دسترسی</span>
                    </NavLink>
                  </li>
                  <li
                    className={`menu-item ${getMenuItemActive("/base/access")}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/base/access">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">آیتم های دسترسی</span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>
          </>
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
